export default "__VITE_ASSET__DA6nHoqR__"